import api from '../../../services/api';

// Performans karnesi PDF'i sunucuda üretilir (QuestPDF). Etiket anahtarları
// backend ReportCardPdfModelBuilder'ın okuduklarıyla BİREBİR aynıdır.
export const REPORT_CARD_PDF_LABEL_KEYS = [
  'docTitle',
  'confidentialManager',
  'confidentialSelf',
  'pagePrefix',
  'identityTitle',
  'identityDepartment',
  'identityRegistration',
  'identityManager',
  'identityEmploymentDate',
  'identityAcknowledged',
  'cardFinalLevel',
  'cardGoalScore',
  'cardGoalScoreSub',
  'cardFeedbackAverage',
  'cardFeedbackAverageSub',
  'cardCombinedScore',
  'sectionGoals',
  'goalsChartNote',
  'sectionGoalDetails',
  'sectionFeedback',
  'competencyNote',
  'competencyTargetNote',
  'questionsTitle',
  'commentsTitle',
  'cardManagerOverallLevel',
  'sectionCalibration',
  'proposedLevel',
  'finalLevel',
  'calibrationApproved',
  'periodClosed',
  'acknowledged',
  'counterNote',
  'signEmployee',
  'signManager',
  'signLine',
  'weight',
  'direction',
  'directionIncrease',
  'directionDecrease',
  'target',
  'actual',
  'cap',
  'dueDate',
  'selfAssessment',
  'deviation',
  'keyResult',
  'progress',
  'employeeScore',
  'managerScore',
  'milestoneStep',
  'stepPending',
  'stepSubmitted',
  'stepAccepted',
  'stepRejected',
  'thresholdCondition',
  'thresholdMet',
  'thresholdNotMet',
  'typeOkr',
  'typeKpi',
  'typeMilestone',
  'typeThreshold',
  'noGoals',
  'noFeedback',
];

export function buildReportCardPdfLabels(t) {
  const labels = {};
  REPORT_CARD_PDF_LABEL_KEYS.forEach((key) => {
    labels[key] = t(`performance.reportCard.pdf.${key}`);
  });
  return labels;
}

/** Content-Disposition: önce filename*=UTF-8''…, sonra filename="…", yoksa fallback. */
export function fileNameFromDisposition(header, fallback) {
  if (!header) return fallback;
  const star = /filename\*\s*=\s*UTF-8''([^;\n]*)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replaceAll('"', ''));
    } catch {
      // bozuk yüzde kodlaması — düz filename'e düş
    }
  }
  const plain = /filename\s*=\s*("([^"]*)"|[^;\n]*)/i.exec(header);
  if (plain) {
    const name = (plain[2] !== undefined ? plain[2] : plain[1]).trim();
    if (name) return name;
  }
  return fallback;
}

/**
 * Content-Disposition okunamazsa (ör. CORS başlığı açılmamış bir ortam) kullanılacak ad: kişi adı da taşınır ki
 * art arda indirilen karneler "Performans-Karnesi (1).pdf" diye birbirine karışmasın. Dosya adında yasak karakterler
 * atılır, boşluklar '-' olur (sunucudaki ReportCardFormat.FileName ile aynı yön).
 */
export function fallbackReportCardFileName(displayName) {
  const slug = (displayName || '')
    // eslint-disable-next-line no-control-regex
    .replace(/[\\/:*?"<>|\u0000-\u001f]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return slug ? `Performans-Karnesi_${slug}.pdf` : 'Performans-Karnesi.pdf';
}

/** Blob'u dosya olarak indirir: bağlantı DOM'a eklenip tıklanır, sonra kaldırılır; nesne adresi bir sonraki turda bırakılır. */
export function saveBlob(blob, fileName) {
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Eşzamanlı revoke bazı Safari/Firefox sürümlerinde indirmeyi iptal eder.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}

/** Başarıda true; hata → false (toast Axios interceptor'ında, bileşende YOK). */
export async function downloadReportCardPdf({
  periodId, employeeId, lang, labels, displayName,
}) {
  try {
    const url = employeeId
      ? `/v1/performance/report-card/${periodId}/${employeeId}`
      : `/v1/my/period-results/${periodId}/report-card`;
    const res = await api.post(url, { lang, labels }, { responseType: 'blob' });
    if (!res?.headers || !res.data) return false;
    const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/pdf' });
    saveBlob(blob, fileNameFromDisposition(res.headers['content-disposition'], fallbackReportCardFileName(displayName)));
    return true;
  } catch {
    return false;
  }
}
